import React, {useCallback, useEffect, useState} from 'react'
import {withTranslation} from 'react-i18next'

import {usersService} from 'services'
import requestHandler from 'utils/requestHandler'
import useUserContext from 'components/User/useUserContext'
import BInput from 'components/Form/Fields/BInput'
import FormHandler from 'components/Form/FormHandler'
import {message} from 'antd'

const BillingInfo = ({t}) => {
  const {user} = useUserContext()

  const [initData, setInitData] = useState(undefined)

  useEffect(() => {
    setInitData(undefined)
    requestHandler(() => usersService.getBillingInfo(user.uuid), 'json')
      .then(r => {
        if (r.success) {
          setInitData(r.data)
        } else {
          setInitData(null)
        }
      })
  }, [user.uuid])

  const submitCallback = useCallback((values, setLoading) => {
    requestHandler(() => usersService.patchBillingInfo(user.uuid, values), 'json')
      .then(r => {
        setLoading(false)
        if (r?.success) {
          message.success(t('Saved ok'))
        }
      })
  }, [t, user.uuid])

  return (
    <div className='basicForm'>
      <h1>{t('Billing info')}</h1>

      {initData ? (
        <FormHandler submitCallback={submitCallback} initialValues={initData}>
          <BInput fieldName='businessName' label={t('Business name')}/>
          <BInput fieldName='street' label={t('Street')}/>
          <BInput fieldName='city' label={t('City')}/>
          <BInput fieldName='zip' label={t('ZIP')}/>
          <BInput fieldName='country' label={t('Country')}/>
          <BInput fieldName='vatId' label={t('Vat ID')}/>
          <BInput fieldName='businessId' label={t('Business ID')}/>
          <BInput fieldName='taxId' label={t('Tax ID')}/>
          <BInput fieldName='variableSymbol' label={t('Variable symbol')}/>
        </FormHandler>
      ) : initData === undefined ? (
        'loading...'
      ) : (
        'error'
      )}
    </div>
  )
}

export default withTranslation()(BillingInfo)
